'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { registrarAcesso } from '@/features/home/store';
import { selectAuthIsAuthenticated } from '@/features/auth/store/selectors';
import { capturePageview } from '@/shared/utils/posthogEvents';

export function UserAccessTracker() {
  const pathname = usePathname();
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectAuthIsAuthenticated);

  useEffect(() => {
    if (!pathname || !isAuthenticated) {
      return;
    }

    if (pathname.startsWith('/login') || pathname.startsWith('/termos-de-uso')) {
      return;
    }

    if (
      typeof window !== 'undefined' &&
      (window as Window & { hj?: (...args: unknown[]) => void }).hj
    ) {
      (window as Window & { hj?: (...args: unknown[]) => void }).hj!('stateChange', pathname);
    }

    capturePageview(pathname);

    dispatch(registrarAcesso(pathname));
  }, [pathname, dispatch, isAuthenticated]);

  return null;
}
